// Hypothesis Engine — React hook around the pure gate (local/env, synchronous).

import { hypothesisEngineGate, type HypothesisGate } from './hypothesisEngineFlag';

export function useHypothesisEngineGate(): HypothesisGate {
  return hypothesisEngineGate();
}
